module.exports = __webpack_public_path__ + "static/media/app-6@2x.16bd889f.png";